import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionData: [], // Store the fetched session data here
  sideBarHistory:[]
};

const chatDataSlice = createSlice({
  name: 'chatData',
  initialState,
  reducers: {
    setSessionData: (state, action) => {
  
      state.sessionData = action.payload; // Store fetched data in state
    },
    setMessageData: (state, action) => {
     
      if(action.payload.assistant){
        state.sessionData.pop();

      }
      state.sessionData.push(action.payload) 
      
     // Store fetched data in state
    },
    setClearSessionData: (state) => {
      state.sessionData = [];
     
    },

    storeSessionResponse: (state, action) => {
  
      state.sideBarHistory = action.payload;
    },

    appendFirstChat: (state, action) => {
    
      state.sideBarHistory.unshift(action.payload); // ✅ Add at the start of the array
    },
    
  },
});



export const { setSessionData , setMessageData ,setClearSessionData ,storeSessionResponse, appendFirstChat} = chatDataSlice.actions;


export default chatDataSlice.reducer;
